import { useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslation } from "react-i18next";
import AuthContext from "context/AuthContext";
import MainContext from "context/MainContext";
import PANEL_TYPES from "core/panelTypes";

const AppSidebar = () => {
    const { user, panel } = useContext(AuthContext);
    const { large, setLargeStatus } = useContext(MainContext);
    const [t] = useTranslation("routes");
    const location = useLocation();

    const collapsed = !large;

    const expandSidebar = () => {
        setLargeStatus(true);
    };

    const collapseSidebar = () => {
        setLargeStatus(false);
    };

    const isActive = (path, exact = false) => {
        if (exact) {
            return location.pathname === path;
        }
        return location.pathname.startsWith(path);
    };

    if (!user || !user.organization || !user.panel) {
        return null;
    }

    return (
        <div className={`sidebar-app d-flex flex-column`} style={{ width: collapsed ? "80px" : "250px" }}>
            <ul className="sidebar-menu">
                <li className="sidebar-item">
                    <button
                        onClick={collapsed ? expandSidebar : collapseSidebar}
                        className="sidebar-link"
                    >
                        <span className="sidebar-icon px-3">
                            <FontAwesomeIcon icon={collapsed ? "chevron-right" : "chevron-left"} />
                        </span>
                    </button>
                </li>

                <li className="sidebar-item">
                    <Link to="/" className={`sidebar-link ${isActive("/", true) ? "active" : ""}`}>
                        <span className="sidebar-icon">
                            <FontAwesomeIcon icon="house" />
                        </span>
                        {!collapsed ? <span className="sidebar-text">{t("labels.home")}</span> : null}
                    </Link>
                </li>

                <li className="sidebar-item">
                    <Link to="/asset-management/" className={`sidebar-link ${isActive("/asset-management/") ? "active" : ""}`}>
                        <span className="sidebar-icon ">
                            <FontAwesomeIcon icon={panel?.panel_type === PANEL_TYPES.WASTE ? "trash-can" : "bridge-water"} />
                        </span>
                        {!collapsed ? <span className="sidebar-text">{t("labels.asset-management")}</span> : null}
                    </Link>
                </li>

                {user.is_admin && (
                    <li className="sidebar-item">
                        <Link to="/device-configuration/" className={`sidebar-link ${isActive("/device-configuration/") ? "active" : ""}`}>
                            <span className="sidebar-icon ">
                                <FontAwesomeIcon icon="pen" />
                            </span>
                            {!collapsed ? <span className="sidebar-text">{t("labels.device-configuration")}</span> : null}
                        </Link>
                    </li>
                )}

                <li className="sidebar-item">
                    <Link to="/data-view/" className={`sidebar-link ${isActive("/data-view/") ? "active" : ""}`}>
                        <span className="sidebar-icon ">
                            <FontAwesomeIcon icon="list" />
                        </span>
                        {!collapsed ? <span className="sidebar-text">{t("labels.data-view")}</span> : null}
                    </Link>
                </li>

                {panel?.panel_type === PANEL_TYPES.WASTE && (
                    <>
                        <li className="sidebar-item">
                            <Link to="/route-management/" className={`sidebar-link ${isActive("/route-management/") ? "active" : ""}`}>
                                <span className="sidebar-icon ">
                                    <FontAwesomeIcon icon="route" />
                                </span>
                                {!collapsed ? <span className="sidebar-text">{t("labels.routes")}</span> : null}
                            </Link>
                        </li>

                        {user.is_admin && (
                            <li className="sidebar-item">
                                <Link to="/fleet-management/" className={`sidebar-link ${isActive("/fleet-management/") ? "active" : ""}`}>
                                    <span className="sidebar-icon ">
                                        <FontAwesomeIcon icon="truck" />
                                    </span>
                                    {!collapsed ? <span className="sidebar-text">{t("labels.fleet-management")}</span> : null}
                                </Link>
                            </li>
                        )}

                        <li className="sidebar-item">
                            <Link to="/reports/" className={`sidebar-link ${isActive("/reports/") ? "active" : ""}`}>
                                <span className="sidebar-icon ">
                                    <FontAwesomeIcon icon="chart-column" />
                                </span>
                                {!collapsed ? <span className="sidebar-text">{t("labels.reports")}</span> : null}
                            </Link>
                        </li>
                    </>
                )}

                <li className="sidebar-item">
                    <Link to="/alerts/" className={`sidebar-link ${isActive("/alerts/") ? "active" : ""}`}>
                        <span className="sidebar-icon ">
                            <FontAwesomeIcon icon="triangle-exclamation" />
                        </span>
                        {!collapsed ? <span className="sidebar-text">{t("labels.alerts")}</span> : null}
                    </Link>
                </li>

                {/* mainteance */}
                <li className="sidebar-item">
                    <Link to="/maintenance/" className={`sidebar-link ${isActive("/maintenance/") ? "active" : ""}`}>
                        <span className="sidebar-icon ">
                            <FontAwesomeIcon icon="wrench" />
                        </span>
                        {!collapsed ? <span className="sidebar-text">{t("labels.maintenance")}</span> : null}
                    </Link>
                </li>
            </ul>

            <ul className="sidebar-menu mt-auto">
                {user.is_superuser && (
                    <>
                        <li className="sidebar-item">
                            <Link to="/advanced/" className={`sidebar-link ${isActive("/advanced/") ? "active" : ""}`}>
                                <span className="sidebar-icon ">
                                    <FontAwesomeIcon icon="terminal" />
                                </span>
                                {!collapsed ? <span className="sidebar-text">{t("labels.advanced")}</span> : null}
                            </Link>
                        </li>

                        <li className="sidebar-item">
                            <Link to="/historic/" className={`sidebar-link ${isActive("/historic/") ? "active" : ""}`}>
                                <span className="sidebar-icon ">
                                    <FontAwesomeIcon icon="clock-rotate-left" />
                                </span>
                                {!collapsed ? <span className="sidebar-text">{t("labels.history")}</span> : null}
                            </Link>
                        </li>
                    </>
                )}

                {user.is_admin && (
                    <li className="sidebar-item">
                        <Link to="/administration/" className={`sidebar-link ${isActive("/administration/") ? "active" : ""}`}>
                            <span className="sidebar-icon ">
                                <FontAwesomeIcon icon="gear" />
                            </span>
                            {!collapsed ? <span className="sidebar-text">{t("labels.administration")}</span> : null}
                        </Link>
                    </li>
                )}
            </ul>
        </div>
    );
};

export default AppSidebar;